import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
  Paper,
  useTheme,
  Snackbar,
  Alert,
  FormControlLabel,
  RadioGroup,
  Radio
} from "@mui/material";
import { subYears } from 'date-fns';
import GoogleIcon from "@mui/icons-material/Google";
import { Swiper, SwiperSlide } from 'swiper/react';
import CircularProgress from "@mui/material/CircularProgress";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useAuth } from "../context/AuthContext";
import reg from "../assets/image/registrationpage1.png.jpg"
import { register, sendotp } from "../services";
import { ImageList, ImageListItem } from '@mui/material';
import { useNavigate } from "react-router-dom";
export default function RegistrationForm() {
  const theme = useTheme();
  const [dob, setDob] = useState("");
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    dob: "",
    password: "",
    country_studied_in:"",
    college:"",
    area_of_study:"",
    expertise:"",
    language_spoken1:"",
    language_spoken2:"",
    about:"",
    role_id:""
  });
  const [role, setRole] = useState("3");

  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const navigate = useNavigate();

  const images = [
    "https://cdn.pixabay.com/photo/2023/08/14/06/53/ai-generated-8188588_960_720.jpg",
    "https://cdn.pixabay.com/photo/2020/08/11/09/23/telemedicine-5472470_960_720.jpg",
    "https://cdn.pixabay.com/photo/2022/12/13/20/12/ai-generated-7652865_960_720.jpg"
  ];

  const handleRegister = async () => {
    setIsLoading(true);
  const finalForm = { ...form, role_id: parseInt(role) }; 
   
    try {
      const response = await sendotp({
        email: form.email,
        is_new: "true",
      });

      if (response.status === 200) {
        navigate("/otp-verify", { state: finalForm })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "OTP failed to send. Please try again.";
      setIsLoading(false);
      setSnackbar({
        open: true,
        message: errMsg,
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(to right, #0f9ba1, #8ee3a8)",
          padding: 2
        }}
      >
        <Grid
          container
          spacing={4}
          maxWidth="lg"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{ color: "white", mb: 3, fontWeight: "bold", fontFamily: "Poppins, sans-serif" }}
            >
              Register Now With GetMentors!
            </Typography>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              sx={{ padding: "10px" }}
              value={role}
              onChange={(e) => {
                const selectedRole = e.target.value;
                setRole(selectedRole);

                // Clear mentor-specific fields when switching to Student
                if (selectedRole === "3") {
                  setForm((prev) => ({
                    ...prev,
                    college: "",
                    about: ""
                  }));
                }
              }}
            >
              <FormControlLabel value="3" control={<Radio />} label="Student" />
              <FormControlLabel value="2" control={<Radio />} label="Mentor" />
            </RadioGroup>

            <Box component="form" display="flex" flexDirection="column" gap={2}>
              <TextField
                fullWidth
                label="First name"
                variant="outlined"
                size="small"
                value={form.first_name}
                onChange={(e) => setForm({ ...form, first_name: e.target.value })}
              />
              <TextField
                fullWidth
                label="Last name"
                variant="outlined"
                size="small"
                value={form.last_name}
                onChange={(e) => setForm({ ...form, last_name: e.target.value })}
              />
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Date of Birth"
                    value={form.dob}
                    onChange={(newValue) =>
                      setForm({ ...form, dob: newValue })
                    }
                    maxDate={subYears(new Date(), 15)}

                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: 'outlined',
                        error: false,
                        helperText: '',
                        sx: {
                          '& .MuiInputBase-root': {
                            background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                            borderRadius: '5px',
                            color: 'white',
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'grey', // default border
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'black',
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'blue',
                          },
                          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'grey !important', // force grey even in error
                          },
                          '& .MuiSvgIcon-root': {
                            color: 'white',
                          },
                          '& .Mui-error': {
                            color: 'white',
                          },
                        },
                      },
                      popper: {
                        sx: {
                          '& .MuiPaper-root': {
                            background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                            color: 'white',
                            borderRadius: 2,
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <TextField
                fullWidth
                label="Phone Number"
                variant="outlined"
                size="small"
                value={form.mobile}
                onChange={(e) => setForm({ ...form, mobile: e.target.value })}
              />
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                size="small"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                size="small"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
              {role === "2" && ( // Show only if 'Mentor' is selected
                <>
                 <TextField
                    fullWidth
                    label="Country Studied-In"
                    variant="outlined"
                    size="small"
                    value={form.country_studied_in}
                    onChange={(e) => setForm({ ...form, country_studied_in: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    label="College"
                    variant="outlined"
                    size="small"
                    value={form.college}
                    onChange={(e) => setForm({ ...form, college: e.target.value })}
                  />
                   <TextField
                    fullWidth
                    label="Area Of Study"
                    variant="outlined"
                    size="small"
                    value={form.area_of_study}
                    onChange={(e) => setForm({ ...form, area_of_study: e.target.value })}
                  />
                   <TextField
                    fullWidth
                    label="Expertise"
                    variant="outlined"
                    size="small"
                    value={form.expertise}
                    onChange={(e) => setForm({ ...form, expertise: e.target.value })}
                  />
                    <TextField
                    fullWidth
                    label="Language Spoken"
                    variant="outlined"
                    size="small"
                    value={form.language_spoken1}
                    onChange={(e) => setForm({ ...form, language_spoken1: e.target.value })}
                  />
                     <TextField
                    fullWidth
                    label="Language Spoken"
                    variant="outlined"
                    size="small"
                    value={form.language_spoken2}
                    onChange={(e) => setForm({ ...form, language_spoken2: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    label="About"
                    multiline
                    rows={3}
                    variant="outlined"
                    size="small"
                    value={form.about}
                    onChange={(e) => setForm({ ...form, about: e.target.value })}
                  />
                </>
              )}

              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: "fit-content",
                  background: "white",
                  color: "#0f9ba1",
                  fontWeight: 600,
                  px: 3,
                  "&:hover": {
                    background: "#e0f7fa"
                  }
                }}
                onClick={handleRegister}
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Verify Email"
                )}
              </Button>


              {/* Divider */}

            </Box>
          </Grid>


          <Grid item xs={12} md={6}>
            <Paper
              elevation={6}
              sx={{
                borderRadius: 10,
                p: 2,
                maxWidth: 400,
                mx: "auto"
              }}
            >

              <Box
                component="img"
                src={reg}
                // alt={`slide-${idx}`}
                sx={{
                  width: "100%",
                  height: 300,
                  objectFit: "contain",
                  borderRadius: 2
                }}
              />

            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
